export default {"src":"/_next/static/media/external-link-gray.9c71ca13.svg","height":15,"width":15};